export default "__VITE_ASSET__DUue_Ce$__"